"use strict";module.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}};